import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import News from './components/News';
import { toBePartiallyChecked } from '@testing-library/jest-dom/dist/matchers';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.newsRef = React.createRef();
    this.loadRef = React.createRef();
    this.state = {
      mode_idx: 0,
      mode: ['sun', 'moon']
    }
  }

  

  handleClick = () => {
    this.newsRef.current.handleHome();
  }

  handleLoad = () => {
    this.newsRef.current.loading_screen();
  }
  handleMode = () => {
    this.setState({mode_idx: +(!this.state.mode_idx)});
    document.body.style.backgroundColor= (this.state.mode_idx===0?'rgb(15,15,20)':'white');
  }


  render() {
    return (
      <div>
        <Header handleClick={this.handleClick} handleMode={this.handleMode} mode={this.state.mode[this.state.mode_idx]} />
        <News ref={this.newsRef} mode={this.state.mode[this.state.mode_idx]}/>
        <Footer handleLoad={this.handleLoad} />
      </div>
    );
  }
}

export default App;